import React from 'react'
import ProductTable from './productTable'

const ProductIndex = (props) => {
    console.log(`props`, props)
    const {userId} = props
    return (
       <ProductTable id={userId} />
    )
}

export default ProductIndex